import groq from 'groq';

import { ASSET, OVERLINE, RICH_TEXT } from '../common';

export const HALO_SHOWCASE = groq`
  _type,
  ${OVERLINE},
  title,
  subtitle,
  description[] {
    ${RICH_TEXT}
  },
  cta {
    title,
    href
  },
  backgroundImage {
    ${ASSET}
  },
  featureImage {
    ${ASSET}
  },
  tooltip {
    tooltipLabel,
    tooltipContent
  },
  statistic {
    value,
    title,
    subtitle[] {
      ${RICH_TEXT}
    }
  },
  isBarChartVisible,
  barChart {
    label[] {
      ${RICH_TEXT}
    },
    items[] {
      _key,
      icon {
        ${ASSET}
      },
      title,
      percentage
    }
  }
`;

export const HALO_SHOWCASE_BLOCK = groq`
  // TODO(TIME-645): drop 'scienceTeaser' once the TIME-531 migration has run on every dataset.
  _type in ['haloShowcase', 'scienceTeaser'] => @-> {
    ${HALO_SHOWCASE}
  }
`;
